import { Transfer, AlternativeTransfer } from "../../../interfaces";

export function isStandardTransfer(data: unknown): data is Transfer {
    return (
      typeof data === 'object' &&
      data !== null &&
      'recurrence' in data &&
      'serviceName' in data &&
      'provider' in data &&
      'providerId' in data
    );
  }
  
  export function isAlternativeTransfer(data: unknown): data is AlternativeTransfer {
    return (
      typeof data === 'object' &&
      data !== null &&
      'type' in data &&
      typeof (data as any).type === 'number' &&
      'items' in data &&
      Array.isArray((data as any).items)
    );
  }